import { render, staticRenderFns } from "./Modifier.vue?vue&type=template&id=72b934d7&"
import script from "./Modifier.vue?vue&type=script&lang=js&"
export * from "./Modifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports